import axios from "axios";
import toast from "react-hot-toast";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// FIX BUG-021: Automatically attach the JWT token to every request
// so the auth middleware on the backend can verify the caller's identity.
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 responses globally — token expired or invalid
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear stale auth data
      localStorage.removeItem("token");
      localStorage.removeItem("userData");
      
      // Only redirect if not already on the login page
      if (!window.location.pathname.includes("/login")) {
        toast.error("Your session has expired. Please log in again.", { duration: 2500 });
        setTimeout(() => {
          window.location.href = "/login";
        }, 2500);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
